import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = { key: 1 }

import { ref, watch } from 'vue';
import { useMagicKeys, whenever } from '@vueuse/core';
import { Dialog as KDialog } from '@progress/kendo-vue-dialogs';
import { Button as KButton } from '@progress/kendo-vue-buttons';
import useTranslations from '@/composables/useTranslations';
import LoaderButton from '@/components/common/loaders/LoaderButton.vue';
import DialogActionsBar from '@/components/common/dialogs/dialogActions/DialogActionsBar.vue';
import Notification from '@/components/common/notification/Notification.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogForm',
  props: {
    title: {},
    confirmButtonText: { default: undefined },
    cancelButtonText: { default: undefined },
    confirmButtonDisabled: { type: Boolean },
    successNotification: { default: undefined },
    errorNotification: { default: undefined },
    isLoading: { type: Boolean }
  },
  emits: ["close", "cancel-btn-clicked", "confirm-btn-clicked"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const { translate: t } = useTranslations();
const keys = useMagicKeys();

const cancelBtnText = ref<string | undefined>(props.cancelButtonText);
const isConfirmBtnVisible = ref<boolean>(true);
const isFormVisible = ref<boolean>(true);

function handleCancelBtnClick() {
  emit('cancel-btn-clicked');
}

function handleConfirmBtnClick() {
  emit('confirm-btn-clicked');
}

function hideFormContent() {
  isFormVisible.value = false;
}

function hideConfirmBtn() {
  cancelBtnText.value = t('Ok');
  isConfirmBtnVisible.value = false;
}

watch(
  () => props.cancelButtonText,
  (newCancelButtonText) => {
    cancelBtnText.value = newCancelButtonText;
  },
);

whenever(keys.escape, () => {
  emit('close');
});

__expose({ hideFormContent, hideConfirmBtn });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KDialog), {
    title: __props.title,
    onClose: _cache[0] || (_cache[0] = () => _ctx.$emit('close'))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.errorNotification)
          ? (_openBlock(), _createBlock(Notification, {
              key: 0,
              "theme-color": "error",
              "with-icon": true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errorNotification, (error, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(error), 1))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (props.successNotification)
          ? (_openBlock(), _createBlock(Notification, {
              key: 1,
              "theme-color": "success",
              "with-icon": true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.successNotification), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isFormVisible.value)
          ? _renderSlot(_ctx.$slots, "default", { key: 2 })
          : _createCommentVNode("", true)
      ]),
      _createVNode(DialogActionsBar, {
        "cancel-button-text": cancelBtnText.value ?? _unref(t)('Cancel'),
        onCancel: handleCancelBtnClick
      }, {
        confirmButtonTemplate: _withCtx(() => [
          (isConfirmBtnVisible.value)
            ? (_openBlock(), _createBlock(_unref(KButton), {
                key: 0,
                "fill-mode": 'flat',
                size: 'large',
                "theme-color": 'primary',
                type: 'submit',
                disabled: __props.confirmButtonDisabled,
                "data-testid": "dialog-form__confirm-btn",
                onClick: handleConfirmBtnClick
              }, {
                default: _withCtx(() => [
                  (__props.isLoading)
                    ? (_openBlock(), _createBlock(LoaderButton, {
                        key: 0,
                        "theme-color": 'primary'
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.confirmButtonText || _unref(t)('Send')), 1))
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["cancel-button-text"])
    ]),
    _: 3
  }, 8, ["title"]))
}
}

})